module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo-gallery"
  }, [_c('StartPageSlider', {
    attrs: {
      "line-title-color": "#F01F51",
      "title": "фотогалерея"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "photo-card"
    }, [_c('div', {
      staticClass: "photo-card_photo"
    }, [_c('AppPicture', {
      attrs: {
        "image": item.imageUrl
      }
    })], 1), _c('div', {
      staticClass: "photo-card_info ui_lines-limit-3"
    }, [_c('span', {
      staticClass: "photo-card_info__title"
    }, [_vm._v(_vm._s(item.title))])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684925d2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/photoGallery/PhotoGallery.vue
// module id = 2c75373999b1eec9d72e
// module chunks = 0